import React, { useState, useEffect } from 'react';
import Product from './DcProduct';
import { assign as _assign, get as _get, forOwn as _forOwn } from 'lodash-es';
import AppliedFilters from '../../abs-filter-components/AppliedFilters';
import ProductSort from '../../dc-utils/ProductSort';
import Spinner from '../dc-spinner/Spinner';
import { toUpper } from 'lodash';

const backingProducts =
  typeof _get(window, 'compatioConfig.shopify') === 'object'
    ? _get(window, 'compatioConfig.compatibleProducts.backingData')
    : [
        { name: '20 lb Dacron', variantId: '34368719814788' },
        { name: '30 lb Dacron', variantId: '34368719847556' },
      ];

const default_sorting = _get(
  window,
  'compatioConfig.compatibleProducts.sorting'
);

const ProductList = ({
  props,
  productData,
  currentCategory,
  setCurrentCategory,
  configData,
  outfitList,
  setOutfitList,
  Loading,
  setLoading,
  setLoader,
  finalArray,
  setFinalArray,
  currentsorting,
  handleChangeSortOrder,
  appliedFilters,
  setAppliedFilters,
  masterVariantList,
  fetchData,
  fetchDataAfteraddprotoCart,
  setShowOptions,
  setOptionsDetails,
  defaultSelection,
  setApplySelectedFilters,
  updateCategoryWiseFilters,
  applySelectedFilters,
  afterApplyFilter,
  setAfterApplyFilter,
  afterApplyFilterNeu,
  setAfterApplyFilterNeu,
  isFull,
  SetIsFull,
  categoryWiseFilters,
  filtersAppliedone,
  setFiltersAppliedone,
  filtersAppliedoneTrue,
  setFiltersAppliedoneTrue,
  setInputData,
  setproAdded,
  setCollapsedProductData,
  stopRunShareFun,
  setStopRunShareFun,
}) => {
  const [productList, setProductList] = useState(productData);

  const [addButtonTitle, setAddButtonTitle] = useState(
    configData.configurator
      ? configData.configurator.add_to_sidebar_wording === ''
        ? 'Add To Outfit'
        : configData.configurator.add_to_sidebar_wording
      : 'Add To Outfit'
  );

  const _outFitButtonText =
    configData.configurator !== undefined
      ? configData.configurator.sidebar_button_heading === ''
        ? 'Add Outfit To Cart'
        : configData.configurator.sidebar_button_heading
      : 'Add Outfit To Cart';

  const isCurrentCategoryAdded = () => {
    const check = finalArray.find(cat => cat === currentCategory);
    return check;
  };

  const getCategoryToLook = (categoryIndex, catType, newFinalArray) => {
    let categoryToLook;
    if (catType === 'default' && categoryIndex != -1) {
      categoryToLook =
        configData.default_categories[categoryIndex + 1] &&
        configData.default_categories[categoryIndex + 1].display_name;
      if (categoryToLook === undefined) {
        categoryToLook = configData.possible_categories.find(
          each => !newFinalArray.includes(each.display_name)
        );
        if (categoryToLook && categoryToLook.display_name !== null)
          categoryToLook = categoryToLook.display_name;
        else {
          categoryToLook = configData.default_categories.find(
            each => !newFinalArray.includes(each.display_name)
          );
          if (categoryToLook && categoryToLook.display_name !== null)
            categoryToLook = categoryToLook.display_name;
        }
      }
      if (newFinalArray.includes(categoryToLook)) {
        categoryToLook = configData.default_categories.find(
          each => !newFinalArray.includes(each.display_name)
        );
        if (categoryToLook && categoryToLook.display_name !== null)
          categoryToLook = categoryToLook.display_name;
      }
    } else {
      categoryToLook =
        configData.possible_categories[categoryIndex + 1] &&
        configData.possible_categories[categoryIndex + 1].display_name;

      if (categoryToLook === undefined || categoryToLook === null) {
        categoryToLook = configData.default_categories.find(
          each => !newFinalArray.includes(each.display_name)
        );
        if (categoryToLook && categoryToLook.display_name !== null)
          categoryToLook = categoryToLook.display_name;
      }
      if (newFinalArray.includes(categoryToLook)) {
        categoryToLook = configData.possible_categories.find(
          each => !newFinalArray.includes(each.display_name)
        );
        if (categoryToLook && categoryToLook.display_name !== null)
          categoryToLook = categoryToLook.display_name;
      }
    }

    if (categoryToLook === undefined && catType === 'default') {
      categoryToLook = configData.possible_categories.find(
        each => !newFinalArray.includes(each.display_name)
      );
      if (categoryToLook && categoryToLook.display_name !== null)
        categoryToLook = categoryToLook.display_name;
    }

    if (categoryToLook === undefined && catType === 'optional') {
      categoryToLook = configData.default_categories.find(
        each => !newFinalArray.includes(each.display_name)
      );
      if (categoryToLook && categoryToLook.display_name !== null)
        categoryToLook = categoryToLook.display_name;
    }
    return categoryToLook;
  };

  const updateCategoryData = productToAdd => {
    window.$('.pagescroll').removeClass('active');
    window.$('#pagescrollactive').addClass('active');
    setTimeout(function() {
      window.$('#dc-header-head').scrollCenter('.active', 300);
    }, 1000);

    if (outfitList.length === 0 && default_sorting !== undefined)
      handleChangeSortOrder('compatioscore_descending');
    if (
      productToAdd.categoryName === 'Reels' ||
      productToAdd.categoryName.split('__')[2] === 'Fly Reel'
    ) {
      //&& backingProducts.length > 0) {
      setShowOptions(true);
      setOptionsDetails({
        show: true,
        details: defaultSelection,
        backingProduct:
          backingProducts.length > 0 ? backingProducts[0].variantId : '',
      });
    }
    if (productToAdd.categoryName !== 'Backing') {
      setLoading(true);

      const newOutfitList = [...outfitList, productToAdd];
      const newFinalArray = [...finalArray, currentCategory];
      setOutfitList(newOutfitList);
      setFinalArray(newFinalArray);
      const isFull =
        configData.default_categories.length +
          configData.possible_categories.filter(
            each => each.display_name != null
          ).length ==
        newOutfitList.filter(each => each.categoryName != 'Backing').length;

      SetIsFull(isFull);
      if (!isFull) {
        let categoryToLook;

        // alert(categoryToLook)
        let categoryIndex = configData.default_categories.findIndex(
          each => each.display_name === currentCategory
        );
        if (categoryIndex < 0) {
          categoryIndex = configData.possible_categories.findIndex(
            each => each.display_name === currentCategory
          );
          categoryToLook = getCategoryToLook(
            categoryIndex,
            'optional',
            newFinalArray
          );
        } else {
          categoryToLook = getCategoryToLook(
            categoryIndex,
            'default',
            newFinalArray
          );
          // alert(categoryToLook)
          // alert(categoryToLook+''+1)
        }
        console.log(
          newOutfitList,
          newFinalArray,
          'newOutfitList',
          categoryToLook,
          categoryIndex
        );
        // console.log(categoryToLook,'categoryToLook',newFinalArray)
        setCurrentCategory(categoryToLook);
        if (categoryToLook !== undefined) {
          setproAdded(true);
          // console.log('testing data');
          // console.log(categoryToLook, 'categoryToLook');
          const addprotocartFilterCheck = [];
          // console.log(
          //   categoryWiseFilters.map(e => e.categoryName),
          //   'categoryWiseFilters rohan'
          // );
          categoryWiseFilters.forEach(element => {
            if (element.categoryName == categoryToLook) {
              element.filterData.forEach(e => {
                addprotocartFilterCheck.push(e);
                // console.log(e, 'element rohan', addprotocartFilterCheck);
              });
            }
          });
          // console.log(addprotocartFilterCheck, 'addprotocartFilterCheck');
          const variantList = newOutfitList.map(outfit => {
            if (outfit.categoryName !== 'Backing')
              return outfit.merchantProductSku;
          });
          // console.log(
          //   appliedFilters,
          //   applySelectedFilters,
          //   'hat',
          //   afterApplyFilter,
          //   afterApplyFilterNeu,
          //   addprotocartFilterCheck
          // );
          setAppliedFilters(addprotocartFilterCheck);
          setAfterApplyFilter(addprotocartFilterCheck);
          setAfterApplyFilterNeu(addprotocartFilterCheck);
          // updateCategoryWiseFilters(addprotocartFilterCheck);
          fetchData(variantList, categoryToLook, addprotocartFilterCheck);
          setCollapsedProductData([]);
        } else {
          setLoading(false);
          // console.log('testing non testting');
        }

        // console.log('testing is not full');
      } else {
        // console.log('testing is full');
        // console.log('testing all');
        setCurrentCategory(undefined);
        // setLoading(false);
      }
    }
  };

  useEffect(() => {
    if (productData.length != 0) {
      setProductList(productData);
      setApplySelectedFilters(false);
      setInputData();
      setStopRunShareFun(true);
      // console.log(productData,'productData')
    }
  }, [productData]);

  useEffect(() => {
    setInputData();
    setStopRunShareFun(true);
  }, [outfitList]);

  let data = [];
  const current = currentCategory;
  // console.log(current, 'currentcurrentcurrent');
  const isAlreaydAdded = isCurrentCategoryAdded();
  // console.log(productList, 'productListproductList');
  if (productList.length !== 0) {
    data = productList.find(cat => cat.categoryName === current);
    // console.log(productList, 'data');
    if (data == undefined) {
      data = [];
    } else {
      setTimeout(function() {
        setLoading(false);
      }, 500);
    }
  }
  let products = <Spinner />;

  if (
    !Loading &&
    data.categoryData !== undefined
    // &&
    // data.categoryData.length !== 0
  ) {
    products = (
      <>
        <AppliedFilters
          appliedFilters={appliedFilters}
          applySelectedFilters={applySelectedFilters}
          setAppliedFilters={setAppliedFilters}
          updateCategoryWiseFilters={updateCategoryWiseFilters}
          setApplySelectedFilters={setApplySelectedFilters}
          afterApplyFilter={afterApplyFilter}
          setAfterApplyFilter={setAfterApplyFilter}
          afterApplyFilterNeu={afterApplyFilterNeu}
          setAfterApplyFilterNeu={setAfterApplyFilterNeu}
          filtersAppliedone={filtersAppliedone}
          setFiltersAppliedone={setFiltersAppliedone}
          filtersAppliedoneTrue={filtersAppliedoneTrue}
          setFiltersAppliedoneTrue={setFiltersAppliedoneTrue}
        />

        <h5 className="dcs-mobile-contain-title">
          {data.categoryData.length}
          {' COMPATIBLE '}
          {current != undefined
            ? toUpper(current).endsWith('S', current.length)
              ? toUpper(current)
              : toUpper(current) + `S `
            : ''}
          <span style={{ color: 'grey', fontSize: '12px' }}>
            ({data.categoryData.length != 0 ? masterVariantList.length : 0}{' '}
            options)
          </span>
        </h5>
        <div className="xrs-sort">
          <ProductSort
            appliedFilters={appliedFilters}
            handleChangeSortOrder={handleChangeSortOrder}
            currentSortOrder={currentsorting}
          />
        </div>
        <h5 className="dcs-desktop-contain-title">
          {data.categoryData.length}
          {' COMPATIBLE '}
          {current != undefined
            ? toUpper(current).endsWith('S', current.length)
              ? toUpper(current)
              : toUpper(current) + `S `
            : ''}
          <span style={{ color: 'grey', fontSize: '12px' }}>
            ({data.categoryData.length != 0 ? masterVariantList.length : 0}{' '}
            options)
          </span>
        </h5>
        <label
          style={{ marginBottom: '5px', fontSize: 'medium' }}
          className="productsmsg"
        >
          {appliedFilters && appliedFilters.length > 0
            ? `Based on above filters`
            : `Compatibility based on products in your outfit`}
        </label>

        {data.categoryData.map((data, index) => {
          return (
            <Product
              key={index}
              productId={data.product}
              addButtonTitle={addButtonTitle}
              data={data}
              sourceMerchantProductSku={props.merchantProductSku}
              sourceCompatioCategoryId={props.categoryId}
              categoryPosition={props.categoryPosition + 1}
              showAddtoCart
              updateCategoryData={updateCategoryData}
              productName={props.productName}
              isReel={currentCategory === 'Reels' ? true : false}
              currentCategory={currentCategory}
              isAlreaydAdded={isAlreaydAdded}
              setLoading={setLoading}
            />
          );
        })}
      </>
    );
  } else if (!Loading) {
    products = (
      <div className="notfinddata">
        {currentCategory != undefined || isFull ? (
          <>
            <AppliedFilters
              appliedFilters={appliedFilters}
              applySelectedFilters={applySelectedFilters}
              setAppliedFilters={setAppliedFilters}
              updateCategoryWiseFilters={updateCategoryWiseFilters}
              setApplySelectedFilters={setApplySelectedFilters}
              afterApplyFilter={afterApplyFilter}
              setAfterApplyFilter={setAfterApplyFilter}
              afterApplyFilterNeu={afterApplyFilterNeu}
              setAfterApplyFilterNeu={setAfterApplyFilterNeu}
              filtersAppliedone={filtersAppliedone}
              setFiltersAppliedone={setFiltersAppliedone}
              filtersAppliedoneTrue={filtersAppliedoneTrue}
              setFiltersAppliedoneTrue={setFiltersAppliedoneTrue}
            />
            <p>
              <label>
                <strong>
                  Based on your outfit, there aren't any compatible{' '}
                  {currentCategory &&
                  toUpper(currentCategory).endsWith('S', currentCategory.length)
                    ? toUpper(currentCategory)
                    : toUpper(currentCategory) + `S`}{' '}
                  in stock
                </strong>
              </label>
            </p>
            <p>
              <label>
                You can try removing some{' '}
                {currentCategory &&
                toUpper(currentCategory).endsWith('S', currentCategory.length)
                  ? toUpper(currentCategory)
                  : toUpper(currentCategory) + `S`}{' '}
                filters, or adding different products in your outfit.
              </label>
            </p>
          </>
        ) : (
          <p>
            <label>
              Your Outfit is ready ! Please click the{' '}
              <strong>{addButtonTitle}</strong> button to proceed.
            </label>
          </p>
        )}
      </div>
    );
  }
  if (isFull) {
    products = (
      <div className="notfinddata">
        <p>
          <label>
            Your Outfit is ready ! Please click the{' '}
            <strong>{_outFitButtonText}</strong> button to proceed.
          </label>
        </p>
      </div>
    );
  }

  return <main>{products}</main>;
};

export default ProductList;
